/* eslint-disable react/prop-types */
import React from 'react'
import FieldVisual from './FieldVisual'

import VenueMap from '../../VenueMap'

const pos = {
    lf: 'translate(-100,-300) scale(3)',
    cf: 'translate(-500,-160) scale(3)',
    rf: 'translate(-850,-300) scale(3)',
    first: 'translate(-900,-1100) scale(4)',
    second: 'translate(-835,-875) scale(4)',
    ss: 'translate(-700,-875) scale(4)',
    third: 'translate(-650,-1050) scale(4)',
    all: '',
}

export default function FieldSVG({ settings, chartOptions, venueId = '7' }) {
    const Venue = VenueMap[venueId]

    if (Venue) {
        const compassVisibility = 'hidden'
        const distancesVisibility = !chartOptions.hideFieldDistances
            ? 'visible'
            : 'hidden'
        return (
            <g id="evp-venue-svg">
                <Venue width={settings.vizWidth} height={settings.vizHeight} />
                {/* I'm sorry for this hack to add Savant specific styles */}
                <style>
                    {`
                        .st3{fill:#b2dfdb;}
                        .st4{font-family:'Roboto Condensed';}
                        .st6{fill:#fff; stroke: #e2e2e2; stroke-width: 0.5;}
                        .st7{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;}
                        .st8{fill:none;stroke:#c2c2c2;stroke-width:0.75;}
                        .st9{fill:#c2c2c2;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}
                        #compass {visibility: ${compassVisibility};}
                        #distances {visibility: ${distancesVisibility};}
                        #TEX .st0{fill:#b2dfdb;}
                        #TEX .st3{fill:#5b5b5b;}
                        #TEX .st0{font-family:'Roboto Condensed';}
                    `}
                </style>
            </g>
        )
    }

    // The old way, keep for stadiums that we don't have copies of
    let svg = FieldVisual(venueId, !chartOptions.hideFieldDistances)
    svg = svg.replace(
        `<svg`,
        `<svg transform="${pos.all}" id="bam-evp-field-svg" width=${settings.vizWidth} height=${settings.vizHeight}`
    )

    // eslint-disable-next-line react/no-danger
    return <g dangerouslySetInnerHTML={{ __html: svg }} />
}
